<template>
  <aside class="aside-menu">
    <h5 class="p-2">GrandShipper Version 1.0</h5>
  </aside>
</template>

<script>
export default {
  name: 'c-aside'
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Aside.vue